import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {FilterBasicLegacySingleSelection} from '@adv-mt/mt-filter-basic-legacy'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import Select, {formSelectSizes} from '@adv-mt/mt-form-select'

const transformToCategoryLabel = label => `-- ${label.toUpperCase()} --`

const LEGACY_WRAPPER = 'legacy'

const FormBodyTypeCategory = ({
  initialSearch = {},
  isBasicContent = false,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const APP_NAME = config.get('APP_NAME')

  const label = `FORM_BODY_TYPE_${APP_NAME}_LABEL`
  const {bodyTypes, BODY_TYPE_CATEGORY, FILTER_NAMES, DEFAULT_BODY_TYPE, DEFAULT_BODY_TYPES} = config.get('search')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  // There are a few bodyTypes that are considered categories and
  // they should be displayed differently.
  const bodyTypeCategoriesIds = Object.values(BODY_TYPE_CATEGORY)
  const {category2Id, bodyTypeIds = DEFAULT_BODY_TYPES} = initialSearch
  const bodyTypeValue = bodyTypeIds.length ? bodyTypeIds : [DEFAULT_BODY_TYPE]
  const currentValue = bodyTypeCategoriesIds.includes(category2Id) ? [category2Id] : bodyTypeValue
  const [firstOfferTypeValue] = currentValue
  const parseBodyTypes = bodyTypeCategory =>
    bodyTypeCategoriesIds.includes(bodyTypeCategory.id)
      ? {
          ...bodyTypeCategory,
          isDisabled: true,
          label: transformToCategoryLabel(i18n.t(bodyTypeCategory.label))
        }
      : {...bodyTypeCategory, label: i18n.t(bodyTypeCategory.label)}
  const bodyTypesParsed = bodyTypes.map(parseBodyTypes)
  const FIRST_OPTION = {id: DEFAULT_BODY_TYPE, label: i18n.t('COMMON.ALL')}
  const allBodyTypes = [FIRST_OPTION, ...bodyTypesParsed]

  const _getLastFilterFor = ({value}) => {
    const isCategory2Id = bodyTypeCategoriesIds.some(id => id === value)
    return isCategory2Id
      ? TRACKING_FILTER_NAMES[FILTER_NAMES.CATEGORY_2]
      : TRACKING_FILTER_NAMES[FILTER_NAMES.BODY_TYPE]
  }

  const _handleOnChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.BODY_TYPE_CATEGORY,
      value: [value],
      lastFilter: _getLastFilterFor({value})
    })
  }

  const handleChangeBodyTypeCategory = ({id}) => _handleOnChange(null, {value: id})

  const handleChange = ({value: selectedValue}) => {
    const [firstValue] = selectedValue
    _handleOnChange(null, {value: firstValue})
  }

  const handleReset = ({filters}) => {
    const [filterName] = filters
    onChange(null, {field: filterName, value: []})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return isBasicContent ? (
      <div className="mt-FormBodyTypeCategoryBasicContent">
        <FilterBasicLegacySingleSelection
          onChange={handleChangeBodyTypeCategory}
          options={allBodyTypes}
          value={currentValue}
        />
      </div>
    ) : (
      <Select
        field={FILTER_NAMES.BODY_TYPE_CATEGORY}
        initialSearch={initialSearch}
        isBasicContent={isBasicContent}
        label={i18n.t(label)}
        onChange={_handleOnChange}
        options={allBodyTypes}
        pageName={pageName}
        size={formSelectSizes.LARGE}
        value={currentValue}
      />
    )
  }
  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON.ALL'),
          label: i18n.t('FORM_BODY_TYPE_COCHES_LABEL'),
          name: FILTER_NAMES.BODY_TYPE_CATEGORY,
          options: bodyTypesParsed,
          type
        }
      ]}
      group={`${FILTER_NAMES.BODY_TYPE_CATEGORY}Group`}
      label={withLabel && i18n.t(label)}
      onChange={({value}) => {
        handleChange({value: value.filter(id => id !== allSelectionsId)})
      }}
      onReset={handleReset}
      overlayContentRef={overlayContentRef}
      placeholder={
        currentValue ? allBodyTypes.find(({id}) => String(id) === String(currentValue))?.label : i18n.t('COMMON.ALL')
      }
      value={{
        [FILTER_NAMES.BODY_TYPE_CATEGORY]: [firstOfferTypeValue ? String(currentValue) : allSelectionsId]
      }}
      wrapper={wrapper}
    />
  )
}

const FormBodyTypeCategoryBasicContent = props => <FormBodyTypeCategory {...props} isBasicContent />

FormBodyTypeCategoryBasicContent.displayName = 'FormBodyTypeCategoryBasicContent'

FormBodyTypeCategory.displayName = 'FormBodyTypeCategory'
FormBodyTypeCategory.propTypes = {
  initialSearch: PropTypes.object,
  isBasicContent: PropTypes.bool,
  pageName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

const MemoFormFormBodyTypeCategory = memo(FormBodyTypeCategory)
const MemoFormFormBodyTypeCategoryBasicContent = memo(FormBodyTypeCategoryBasicContent)

export {
  MemoFormFormBodyTypeCategory as FormFormBodyTypeCategory,
  MemoFormFormBodyTypeCategoryBasicContent as FormBodyTypeCategoryBasicContent
}
export default MemoFormFormBodyTypeCategory
